import React, { useEffect, useState } from 'react';
import { DataUnavailableOverlay, LoadingSpinner } from '../../components';
import { getUrlQueryParams, getSelectedSubjects, getSubjectLevel } from '../../actions';
import { useAppContext } from '../../context/AppState.jsx';
import styles from '../../pages/Data/partials/AppRouter/styles.css';
import i18n from '../../i18n';

export default function DataUnavailableNotice() {
	const [state] = useAppContext();
	const [dismissed, setDismissed] = useState(false);
	const urlParams = getUrlQueryParams();

	useEffect(() => {
		setDismissed(false);
	}, [urlParams.meas, urlParams.loc, urlParams.view, urlParams.subview]);

	if (!state?.indexedYml || !state?.descriptors || !state?.externalData) {
		return <></>;
	}

	const subjects = getSelectedSubjects(state);
	const tableRows = state?.dataTable || [];

	const parseShowAAT = () => {
		try {
			if (urlParams.showAAT === undefined || urlParams.showAAT === 'undefined' || urlParams.showAAT === null) {
				return null;
			}
			return JSON.parse(urlParams.showAAT);
		} catch (e) {
			return null;
		}
	};

	const showForView = urlParams.view === 'table' && urlParams.subview === 'score' && parseShowAAT() === 4;
	// show warning when a subject below category level is selected
	const invalidLevel = subjects.some((s) => getSubjectLevel(state, s) > 1);
	const noData = tableRows.length === 0;

	if (!showForView || dismissed || (!invalidLevel && !noData)) {
		return null;
	}

	const message = i18n.t(
		'Please note - it is only possible to display Significant Changes highlights for Overall Governance and the 4 main categories.',
	);

	return <DataUnavailableOverlay message={message} onDismiss={() => setDismissed(true)} />;
}
